import script from "./JobsPanelListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobsPanelListItem.vue?vue&type=script&setup=true&lang=ts"

import "./JobsPanelListItem.vue?vue&type=style&index=0&id=2108b774&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2108b774"]])

export default __exports__